document.addEventListener('DOMContentLoaded', function() {
  // Initialize bundle functionality
  initBundleSelections();
  
  function initBundleSelections() {
    // Find the main product form with the form-with-extras class
    const productForm = document.querySelector('form.form-with-extras');
    if (!productForm) {
      console.error('Product form with class form-with-extras not found');
      return;
    }
    
    console.log('Bundle script initialized - found form with extras');
    
    // Log the existing hidden inputs for debugging
    let existingInputs = productForm.querySelectorAll('input[name^="extra_variant_id"]');
    console.log(`Found ${existingInputs.length} existing hidden inputs for bundle items`);
    
    // Store bundles and their selected items - organize by columns
    let columnSelections = {};
    
    // Setup dropdowns for product selection
    setupCustomDropdowns();
    
    // Setup variant buttons
    setupVariantButtons();
    
    // Setup variant selects
    setupVariantSelects();
    
    // Setup custom variant selects
    setupCustomVariantSelects(); // Add this line
    
    // Setup bundle choose buttons
    setupBundleChooseButtons();
    
    // Setup bundle add buttons
    document.querySelectorAll('.bundle-add-btn').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (this.disabled) return;
        
        // Find the column wrapper for this button
        const bundleItem = this.closest('.upsell-bundle__item');
        const bundleList = bundleItem.closest('.upsell-bundle__list');
        const columnWrapper = bundleItem.closest('.upsell-bundle__list-wrapper');
        
        // Find the placeholder element where we'll show the selected product
        const placeholderElement = bundleList.querySelector('.selected-product-placeholder');
        
        // Get variant ID from button attribute
        const variantId = this.getAttribute('data-variant-id');
        
        // Find or create column selection tracking
        const columnId = columnWrapper.getAttribute('data-column-id') || 
          `column-${Array.from(document.querySelectorAll('.upsell-bundle__list-wrapper')).indexOf(columnWrapper)}`;
        
        if (!columnSelections[columnId]) {
          // Number of items that can be added to this column
          const requiredItems = parseInt(columnWrapper.getAttribute('data-number-of-items')) || 1;
          
          columnSelections[columnId] = {
            element: columnWrapper,
            requiredItems: requiredItems,
            selectedItems: 0,
            addedButtons: [] // Keep track of which buttons have been added
          };
          
          console.log(`Created column selection tracking for ${columnId} with ${requiredItems} required items`);
        }
        
        // Toggle functionality - add or remove
        if (!this.classList.contains('added')) {
          // Toggle on - Add to bundle
          this.classList.add('added');
          this.textContent = 'Remove';
          
          // Hide the list content
          const listContent = bundleItem.closest('.upsell-bundle__list-content');
          if (listContent) {
            listContent.style.display = 'none';
            
            // Show the choose button again
            const chooseBtn = bundleList.querySelector('.bundle-choose-btn');
            if (chooseBtn) {
              chooseBtn.style.display = 'block';
            }
          }
          
          // Get product details to display in the placeholder
          const productTitle = bundleItem.querySelector('.upsell-bundle__title').textContent;
          const productImage = bundleItem.querySelector('.upsell-bundle__image').src;
          
          // Get variant details from button selection
          let variantTitle = '';
          const selectedVariant = bundleItem.querySelector('.bundle-variant-button.selected');
          const variantSelect = bundleItem.querySelector('.bundle-variant-select');

          if (selectedVariant) {
            variantTitle = selectedVariant.textContent.trim();
          } else if (variantSelect) {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            if (selectedOption) {
              variantTitle = selectedOption.textContent.trim();
            }
          }
          
          // Hide variant buttons/selects when item is added
          const variantButtons = bundleItem.querySelector('.bundle-variant-buttons');
          const variantSelectElement = bundleItem.querySelector('.bundle-variant-select');

          if (variantButtons) {
            variantButtons.style.display = 'none';
          }

          if (variantSelectElement) {
            variantSelectElement.style.display = 'none';
          }
          
          // Update the placeholder with product info
          if (placeholderElement) {
            placeholderElement.innerHTML = `
              <div class="selected-product">
                <div class="selected-product-image">
                  <img src="${productImage}" alt="${productTitle}">
                </div>
                <div class="selected-product-info">
                  <div class="selected-product-title">${productTitle}</div>
                  ${variantTitle !== productTitle ? `<div class="selected-product-variant">${variantTitle.replace(' - Sold Out', '')}</div>` : ''}
                </div>
              </div>
            `;
            placeholderElement.style.display = 'block';
            
            // Add the populated class to the list
            if (bundleList) {
              bundleList.classList.add('upsell-bundle__list--populated');
            }
          }
          
          // Add to column selection tracking
          columnSelections[columnId].addedButtons.push(this);
          columnSelections[columnId].selectedItems = columnSelections[columnId].addedButtons.length;
          
          // Get the name for the hidden input
          const inputName = this.getAttribute('name');
          
          // Check if the hidden input exists already
          let input = productForm.querySelector(`input[name="${inputName}"]`);
          
          // Create it if it doesn't exist
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = inputName;
            productForm.appendChild(input);
            console.log(`Created hidden input with name ${inputName}`);
          }
          
          // Set the variant ID in the hidden input
          input.value = variantId;
          
          console.log(`Added variant ${variantId} to hidden input ${inputName}`);
          
          // Change the choose button to say "Change" instead of "Select"
          const chooseBtn = bundleList.querySelector('.bundle-choose-btn');
          if (chooseBtn) {
            chooseBtn.textContent = 'Change Item';
            chooseBtn.classList.add('bundle-choose-btn--change');
          }
        } else {
          // Toggle off - Remove from bundle
          this.classList.remove('added');
          this.textContent = 'Add item';
          
          // Show variant buttons/selects again
          const variantButtons = bundleItem.querySelector('.bundle-variant-buttons');
          const variantSelectElement = bundleItem.querySelector('div.bundle-variant-select');

          if (variantButtons) {
            variantButtons.style.display = '';
          }

          if (variantSelectElement) {
            variantSelectElement.style.display = '';
          }
          
          // Remove from column selection tracking
          const buttonIndex = columnSelections[columnId].addedButtons.indexOf(this);
          if (buttonIndex !== -1) {
            columnSelections[columnId].addedButtons.splice(buttonIndex, 1);
          }
          
          columnSelections[columnId].selectedItems = columnSelections[columnId].addedButtons.length;
          
          // Clear the hidden input
          const inputName = this.getAttribute('name');
          let input = productForm.querySelector(`input[name="${inputName}"]`);
          
          if (input) {
            input.value = '';
            console.log(`Cleared input ${inputName}`);
          }
          
          // Clear the placeholder
          if (placeholderElement) {
            placeholderElement.innerHTML = '';
            placeholderElement.style.display = 'none';
            
            // Remove the populated class from the list
            if (bundleList) {
              bundleList.classList.remove('upsell-bundle__list--populated');
            }
          }
          
          // Reset the choose button if there's no selection
          const chooseBtn = bundleList.querySelector('.bundle-choose-btn');
          if (chooseBtn) {
            chooseBtn.textContent = 'Select Item';
            chooseBtn.classList.remove('bundle-choose-btn--change');
          }
        }
        
        // Check column completion after toggle
        checkColumnCompletion(columnId);
        
        // Update button count in the bundle
        updateButtonCount();
        
        // Update bundle pricing when items are added/removed
        const columnElement = bundleItem.closest('.upsell-bundle__column');
        updateBundlePricing(columnElement);
        
        return false; // Prevent default and bubbling
      });
    });
    
    // Setup variant button click behavior
    function setupVariantButtons() {
      document.querySelectorAll('.bundle-variant-button').forEach(button => {
        button.addEventListener('click', function() {
          if (this.classList.contains('sold-out') || this.disabled) return;
          
          // Find all variant buttons in this product
          const bundleItem = this.closest('.upsell-bundle__item');
          const variantButtons = bundleItem.querySelectorAll('.bundle-variant-button');
          
          // Remove selected class from all buttons
          variantButtons.forEach(btn => btn.classList.remove('selected'));
          
          // Add selected class to this button
          this.classList.add('selected');
          
          // Get the variant ID
          const variantId = this.getAttribute('data-variant-id');
          
          // Update the add button's variant ID
          const addButton = bundleItem.querySelector('.bundle-add-btn');
          if (addButton) {
            // Check if variant changed while item was added
            const wasAdded = addButton.classList.contains('added');
            const previousVariantId = addButton.getAttribute('data-variant-id');
            
            // Update variant ID on add button
            addButton.setAttribute('data-variant-id', variantId);
            
            // If variant changed and item was already added, reset added state
            if (wasAdded && previousVariantId !== variantId) {
              addButton.classList.remove('added');
              addButton.textContent = 'Add item';
              

              // Clear hidden input
              const inputName = addButton.getAttribute('name');
              if (inputName) {
                const input = productForm.querySelector(`input[name="${inputName}"]`);
                if (input) input.value = '';
              }
              

              // Clear placeholder
              const bundleList = bundleItem.closest('.upsell-bundle__list');
              if (bundleList) {
                const placeholder = bundleList.querySelector('.selected-product-placeholder');
                if (placeholder) {
                  placeholder.innerHTML = '';
                  placeholder.style.display = 'none';
                  bundleList.classList.remove('upsell-bundle__list--populated');
                }
                
                // Reset choose button
                const chooseBtn = bundleList.querySelector('.bundle-choose-btn');
                if (chooseBtn) {
                  chooseBtn.textContent = 'Select Item';
                  chooseBtn.classList.remove('bundle-choose-btn--change');
                }
              }
              

              // Update column state
              const columnWrapper = bundleItem.closest('.upsell-bundle__list-wrapper');
              if (columnWrapper) {
                const columnId = columnWrapper.getAttribute('data-column-id') || 
                  `column-${Array.from(document.querySelectorAll('.upsell-bundle__list-wrapper')).indexOf(columnWrapper)}`;
                
                if (columnSelections[columnId]) {
                  const btnIndex = columnSelections[columnId].addedButtons.indexOf(addButton);
                  if (btnIndex !== -1) {
                    columnSelections[columnId].addedButtons.splice(btnIndex, 1);
                  }
                  
                  columnSelections[columnId].selectedItems = columnSelections[columnId].addedButtons.length;
                  checkColumnCompletion(columnId);
                }
              }
            }
          }
          
          // Update hidden select if present
          const hiddenSelect = bundleItem.querySelector('.bundle-variant-selector');
          if (hiddenSelect) hiddenSelect.value = variantId;
        });
      });
    }
    
    // Setup variant selects for product variant selection
    function setupVariantSelects() {
      document.querySelectorAll('.bundle-variant-select').forEach(select => {
        const bundleItem = select.closest('.upsell-bundle__item');
        if (!bundleItem) return;
        
        const addButton = bundleItem.querySelector('.bundle-add-btn');
        if (!addButton) return;
        
        // Set initial variant ID and price on add button
        const initialOption = select.options[select.selectedIndex];
        if (initialOption) {
          addButton.setAttribute('data-variant-id', initialOption.value);
          addButton.setAttribute('data-variant-price', initialOption.getAttribute('data-price') || '0');
        }
        
        // Handle select change
        select.addEventListener('change', function() {
          const selectedOption = this.options[this.selectedIndex];
          const variantId = selectedOption.value;
          const variantPrice = selectedOption.getAttribute('data-price') || '0';
          
          // Declare the missing variables here
          const wasAdded = addButton.classList.contains('added');
          const previousVariantId = addButton.getAttribute('data-variant-id');
          
          // Update variant ID and price on add button
          addButton.setAttribute('data-variant-id', variantId);
          addButton.setAttribute('data-variant-price', variantPrice);
          
          // Update bundle pricing immediately when variant changes (even if not added yet)
          const columnElement = bundleItem.closest('.upsell-bundle__column');
          updateBundlePricing(columnElement);
          
          // If variant changed and item was already added, reset added state
          if (wasAdded && previousVariantId !== variantId) {
            // Get column info before reset
            const columnWrapper = bundleItem.closest('.upsell-bundle__list-wrapper');
            const columnId = columnWrapper.getAttribute('data-column-id') || 
              `column-${Array.from(document.querySelectorAll('.upsell-bundle__list-wrapper')).indexOf(columnWrapper)}`;
            
            // Toggle off - Remove from bundle
            addButton.classList.remove('added');
            addButton.textContent = 'Add item';
            
            // Show variant buttons/selects again
            const variantButtons = bundleItem.querySelector('.bundle-variant-buttons');
            const variantSelectElement = bundleItem.querySelector('div.bundle-variant-select');

            if (variantButtons) {
              variantButtons.style.display = '';
            }

            if (variantSelectElement) {
              variantSelectElement.style.display = '';
            }
            
            // Remove from column selection tracking
            if (columnSelections[columnId]) {
              const buttonIndex = columnSelections[columnId].addedButtons.indexOf(addButton);
              if (buttonIndex !== -1) {
                columnSelections[columnId].addedButtons.splice(buttonIndex, 1);
              }
              
              columnSelections[columnId].selectedItems = columnSelections[columnId].addedButtons.length;
            }
            
            // Clear the hidden input
            const inputName = addButton.getAttribute('name');
            let input = productForm.querySelector(`input[name="${inputName}"]`);
            
            if (input) {
              input.value = '';
              console.log(`Cleared input ${inputName}`);
            }
            
            // Clear the placeholder
            const bundleList = bundleItem.closest('.upsell-bundle__list');
            const placeholder = bundleList.querySelector('.selected-product-placeholder');
            if (placeholder) {
              placeholder.innerHTML = '';
              placeholder.style.display = 'none';
              bundleList.classList.remove('upsell-bundle__list--populated');
            }
            
            // Reset the choose button if there's no selection
            const chooseBtn = bundleList.querySelector('.bundle-choose-btn');
            if (chooseBtn) {
              chooseBtn.textContent = 'Select Item';
              chooseBtn.classList.remove('bundle-choose-btn--change');
            }
            
            // Check column completion after reset
            checkColumnCompletion(columnId);
            
            // Update pricing after reset
            updateBundlePricing(columnElement);
          }
          
          // Update hidden select if present (for backward compatibility)
          const hiddenSelect = bundleItem.querySelector('.bundle-variant-selector');
          if (hiddenSelect) hiddenSelect.value = variantId;
        });
        
        // Initial pricing update
        const columnElement = bundleItem.closest('.upsell-bundle__column');
        if (columnElement) {
          updateBundlePricing(columnElement);
        }
      });
    }
    
    // Add this function after your setupVariantSelects function (around line 350):
    function setupCustomVariantSelects() {
      document.querySelectorAll('.bundle-variant-custom-select').forEach(customSelect => {
        const selectedElement = customSelect.querySelector('.bundle-variant-custom-select__selected');
        const dropdown = customSelect.querySelector('.bundle-variant-custom-select__dropdown');
        const options = dropdown.querySelectorAll('.bundle-variant-custom-select__option');
        const bundleItem = customSelect.closest('.upsell-bundle__item');
        const hiddenSelect = bundleItem?.querySelector('select.bundle-variant-select');
        const addButton = bundleItem?.querySelector('.bundle-add-btn');
        
        if (!selectedElement || !dropdown || !bundleItem) return;
        
        console.log('Setting up custom variant select for:', bundleItem.querySelector('.upsell-bundle__title')?.textContent);
        
        // Toggle dropdown
        selectedElement.addEventListener('click', function(e) {
          e.stopPropagation();
          
          console.log('Custom select clicked');
          
          // Close other custom selects
          document.querySelectorAll('.bundle-variant-custom-select.open').forEach(select => {
            if (select !== customSelect) select.classList.remove('open');
          });
          
          customSelect.classList.toggle('open');
          console.log('Custom select open state:', customSelect.classList.contains('open'));
        });
        
        // Handle option selection
        options.forEach(option => {
          option.addEventListener('click', function(e) {
            e.stopPropagation();
            
            const value = this.getAttribute('data-value');
            const price = this.getAttribute('data-price');
            const text = this.textContent.trim();
            
            console.log('Custom option selected:', text, 'Value:', value, 'Price:', price);
            
            // Update visual selection
            options.forEach(opt => opt.removeAttribute('data-selected'));
            this.setAttribute('data-selected', 'true');
            selectedElement.textContent = text;
            
            // Update hidden select
            if (hiddenSelect) {
              hiddenSelect.value = value;
              // Trigger change event on hidden select to maintain existing functionality
              const changeEvent = new Event('change', { bubbles: true });
              hiddenSelect.dispatchEvent(changeEvent);
              console.log('Triggered change event on hidden select');
            }
            
            // Update add button
            if (addButton) {
              const wasAdded = addButton.classList.contains('added');
              const previousVariantId = addButton.getAttribute('data-variant-id');
              
              addButton.setAttribute('data-variant-id', value);
              addButton.setAttribute('data-variant-price', price);
              
              // If variant changed while already added, reset state
              if (wasAdded && previousVariantId !== value) {
                console.log('Variant changed while added, resetting state');
                addButton.classList.remove('added');
                addButton.textContent = 'Add item';
                
                // Clear hidden input
                const inputName = addButton.getAttribute('name');
                if (inputName) {
                  const input = document.querySelector(`form.form-with-extras input[name="${inputName}"]`);
                  if (input) {
                    input.value = '';
                    console.log('Cleared input:', inputName);
                  }
                }
                
                // Update pricing
                const columnElement = bundleItem.closest('.upsell-bundle__column');
                if (columnElement && typeof updateBundlePricing === 'function') {
                  updateBundlePricing(columnElement);
                }
              }
            }
            
            // Close dropdown
            customSelect.classList.remove('open');
            
            // Update pricing
            const columnElement = bundleItem.closest('.upsell-bundle__column');
            if (columnElement && typeof updateBundlePricing === 'function') {
              updateBundlePricing(columnElement);
            }
          });
        });
        
        // Initialize with first option
        const firstOption = options[0];
        if (firstOption && hiddenSelect) {
          const initialValue = firstOption.getAttribute('data-value');
          const initialPrice = firstOption.getAttribute('data-price');
          
          hiddenSelect.value = initialValue;
          if (addButton) {
            addButton.setAttribute('data-variant-id', initialValue);
            addButton.setAttribute('data-variant-price', initialPrice);
          }
          
          console.log('Initialized custom select with:', initialValue, initialPrice);
        }
      });
      
      // Close dropdowns when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.bundle-variant-custom-select')) {
          document.querySelectorAll('.bundle-variant-custom-select.open').forEach(select => {
            select.classList.remove('open');
          });
        }
      });
    }
    
    // Setup custom dropdowns for product selection
    function setupCustomDropdowns() {
      document.querySelectorAll('.upsell-bundle__dropdown').forEach(dropdown => {
        const selectedItem = dropdown.querySelector('.upsell-bundle__selected-item');
        const list = dropdown.querySelector('.upsell-bundle__list-items');
        if (!selectedItem || !list) return;

        const items = list.querySelectorAll('li');
        const bundleList = dropdown.closest('.upsell-bundle__list');
        if (!bundleList) return;
        const bundleProducts = bundleList.querySelector('.upsell-bundle__products');
        if (!bundleProducts) return;
        const bundleItems = bundleProducts.querySelectorAll('.upsell-bundle__item');

        if (items.length <= 1) {
          dropdown.style.display = 'none';
        }

        if (items.length > 0) {
          selectedItem.textContent = items[0].textContent.trim();
          items[0].classList.add('selected');
          const firstTitle = items[0].textContent.trim();
          bundleItems.forEach(bi => {
            const t = bi.querySelector('.upsell-bundle__title').textContent.trim();
            bi.style.display = t === firstTitle ? 'block' : 'none';
          });
        }

        selectedItem.addEventListener('click', e => {
          e.stopPropagation();
          document.querySelectorAll('.upsell-bundle__dropdown.open').forEach(d => {
            if (d !== dropdown) d.classList.remove('open');
          });
          dropdown.classList.toggle('open');
        });

        items.forEach(li => {
          li.addEventListener('click', () => {
            selectedItem.textContent = li.textContent.trim();
            items.forEach(i => i.classList.remove('selected'));
            li.classList.add('selected');
            const chosen = li.textContent.trim();
            bundleItems.forEach(bi => {
              const t = bi.querySelector('.upsell-bundle__title').textContent.trim();
              bi.style.display = t === chosen ? 'block' : 'none';
            });
            dropdown.classList.remove('open');
          });
        });
      });

      document.addEventListener('click', e => {
        if (!e.target.closest('.upsell-bundle__dropdown')) {
          document.querySelectorAll('.upsell-bundle__dropdown.open').forEach(d => {
            d.classList.remove('open');
          });
        }
      });
    }
    
    // Setup bundle choose buttons to toggle visibility of content
    function setupBundleChooseButtons() {
      document.querySelectorAll('.bundle-choose-btn').forEach(button => {
        const listContent = button.nextElementSibling;
        const bundleList = button.closest('.upsell-bundle__list');
        const placeholderElement = bundleList ? bundleList.querySelector('.selected-product-placeholder') : null;
        
        // Initially hide the content
        if (listContent && listContent.classList.contains('upsell-bundle__list-content')) {
          listContent.style.display = 'none';
        }
        
        // Add click event to toggle visibility
        button.addEventListener('click', function() {
          if (listContent) {
            const isVisible = listContent.style.display !== 'none';
            
            // Hide all other open content sections first
            document.querySelectorAll('.upsell-bundle__list-content').forEach(content => {
              content.style.display = 'none';
            });
            
            // Toggle this content section
            if (isVisible) {
              listContent.style.display = 'none';
              // Show the button again when content is closed
              this.style.display = 'block';
              

              // If placeholder has content, show it again
              if (placeholderElement && placeholderElement.querySelector('.selected-product')) {
                placeholderElement.style.display = 'block';
              }
            } else {
              listContent.style.display = 'block';
              // Hide the button when content is shown
              this.style.display = 'none';
              

              // Hide the placeholder when showing content
              if (placeholderElement) {
                placeholderElement.style.display = 'none';
              }
              
            
              // Show all variant buttons/selects when opening the change view
              const bundleItems = listContent.querySelectorAll('.upsell-bundle__item');
              bundleItems.forEach(item => {
                const variantButtons = item.querySelector('.bundle-variant-buttons');
                const variantSelect = item.querySelector('div.bundle-variant-select');
                
                if (variantButtons) {
                  variantButtons.style.display = '';
                }
                
                if (variantSelect) {
                  variantSelect.style.display = '';
                }
              });
              

              // If there's only one product in the dropdown, automatically select it
              const dropdown = listContent.querySelector('.upsell-bundle__dropdown');
              const items = dropdown ? dropdown.querySelectorAll('.upsell-bundle__list-items li') : [];
              if (items.length === 1) {
                items[0].click();
              }
            }
          }
        });
      });
      
      // Initially hide all placeholders that don't have content
      document.querySelectorAll('.selected-product-placeholder').forEach(placeholder => {
        if (!placeholder.innerHTML.trim() || placeholder.innerHTML === 'Select an item' || placeholder.innerHTML === 'Load chosen product image and title and variant here') {
          placeholder.style.display = 'none';
        } else {
          // If placeholder has content, make sure the button has the change class
          const bundleList = placeholder.closest('.upsell-bundle__list');
          const chooseBtn = bundleList ? bundleList.querySelector('.bundle-choose-btn') : null;
          if (chooseBtn) {
            chooseBtn.textContent = 'Change Item';
            chooseBtn.classList.add('bundle-choose-btn--change');
          }
        }
      });
      
      // Close all content sections when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.upsell-bundle__list-content') && 
            !e.target.classList.contains('bundle-choose-btn')) {
          document.querySelectorAll('.upsell-bundle__list-content').forEach(content => {
            const button = content.previousElementSibling;
            const bundleList = content.closest('.upsell-bundle__list');
            const placeholder = bundleList ? bundleList.querySelector('.selected-product-placeholder') : null;
            
            if (button && button.classList.contains('bundle-choose-btn')) {
              button.style.display = 'block';
              

              // If placeholder has content, show it again and ensure button has change class
              if (placeholder && placeholder.querySelector('.selected-product')) {
                placeholder.style.display = 'block';
                
                if (!button.classList.contains('bundle-choose-btn--change')) {
                  button.textContent = 'Change Item';
                  button.classList.add('bundle-choose-btn--change');
                }
              } else {
                // If no content, make sure button doesn't have change class
                button.textContent = 'Select Item';
                button.classList.remove('bundle-choose-btn--change');
              }
            }
            content.style.display = 'none';
          });
        }
      });
    }
    
    // Find a hidden input by name or best match
    function findBestMatchingInput(form, inputName) {
      const input = form.querySelector(`input[name="${inputName}"]`);
      if (input) return input;
      
      // If exact match not found, try to find the closest match
      const allHiddenInputs = form.querySelectorAll('input[type="hidden"]');
      let bestMatch = null;
      
      for (const inp of allHiddenInputs) {
        if (inp.name.includes(inputName) || inputName.includes(inp.name)) {
          if (!bestMatch || inp.name.length > bestMatch.name.length) {
            bestMatch = inp;
          }
        }
      }
      
      return bestMatch;
    }
    
    // Check if a column has the required number of items
    function checkColumnCompletion(columnId) {
      const column = columnSelections[columnId];
      if (!column) return;
      
      const requiredItems = column.requiredItems;
      const selectedCount = column.addedButtons.length;
      
      console.log(`Checking column completion: ${columnId}, ${selectedCount}/${requiredItems} items`);
      
      // Get all added buttons in this column, sorted by when they were added (newest first)
      const sortedButtons = [...column.addedButtons].sort((a, b) => {
        return column.addedButtons.indexOf(b) - column.addedButtons.indexOf(a);
      });
      
      // If we have more buttons selected than required, keep only the most recent ones
      if (sortedButtons.length > requiredItems) {
        console.log(`Too many items selected (${sortedButtons.length}/${requiredItems}). Keeping only the most recent ${requiredItems}.`);
        
        // Get buttons that exceed the limit (oldest ones)
        const buttonsToRemove = sortedButtons.slice(requiredItems);
        
        // Reset these buttons UI
        buttonsToRemove.forEach(button => {
          button.classList.remove('added');
          button.textContent = 'Add item';
          
          // Remove from the column's tracked buttons
          const index = column.addedButtons.indexOf(button);
          if (index !== -1) {
            column.addedButtons.splice(index, 1);
          }
          
          // Clear the hidden input
          const inputName = button.getAttribute('name');
          if (inputName) {
            let input = productForm.querySelector(`input[name="${inputName}"]`);
            if (!input) {
              input = findBestMatchingInput(productForm, inputName);
            }
            
            if (input) {
              input.value = '';
              console.log(`Cleared input ${input.name} because it exceeds the required limit`);
            }
          }
          
          // Show variant buttons/selects again
          const bundleItem = button.closest('.upsell-bundle__item');
          if (bundleItem) {
            const variantButtons = bundleItem.querySelector('.bundle-variant-buttons');
            const variantSelectElement = bundleItem.querySelector('div.bundle-variant-select');

            if (variantButtons) {
              variantButtons.style.display = '';
            }

            if (variantSelectElement) {
              variantSelectElement.style.display = '';
            }
          }
        });
        
        // Update the count after removing excess buttons
        column.selectedItems = column.addedButtons.length;
      }
      
      // Find the parent upsell-bundle__column element
      const columnWrapper = column.element;
      const columnElement = columnWrapper ? columnWrapper.closest('.upsell-bundle__column') : null;
      
      // Now check if we have enough items
      if (column.selectedItems >= requiredItems) {
        // Update all hidden inputs for the selected buttons
        column.addedButtons.slice(0, requiredItems).forEach(button => {
          const inputName = button.getAttribute('name');
          const variantId = button.getAttribute('data-variant-id');
          
          const input = productForm.querySelector(`input[name="${inputName}"]`) || 
                       findBestMatchingInput(productForm, inputName);
          
          if (input) {
            input.value = variantId;
            console.log(`Setting hidden input ${inputName} to ${variantId}`);
          }
        });
        
        // Add the completion class to the column element (not the wrapper)
        if (columnElement) {
          columnElement.classList.add('upsell-bundle__column--complete');
          console.log(`Column ${columnId} is now complete with ${column.selectedItems}/${requiredItems} items - Added class to column element`);
        } else {
          // Fallback to the wrapper if column element not found
          column.element.classList.add('upsell-bundle__list-wrapper--complete');
          console.log(`Column ${columnId} is now complete with ${column.selectedItems}/${requiredItems} items - Added class to wrapper (fallback)`);
        }
      } else {
        // Not enough items yet, clear ALL hidden inputs for this column
        column.element.querySelectorAll('.bundle-add-btn').forEach(button => {
          const btnName = button.getAttribute('name');
          if (btnName) {
            let input = productForm.querySelector(`input[name="${btnName}"]`);
            if (!input) {
              input = findBestMatchingInput(productForm, btnName);
            }
            
            if (input) {
              input.value = '';
              console.log(`Cleared input ${input.name} because column doesn't have enough items`);
            }
          }
        });
        
        // Find the parent upsell-bundle__column element
        const columnElement = columnWrapper ? columnWrapper.closest('.upsell-bundle__column') : null;
        
        // Remove the completion class from column element
        if (columnElement) {
          columnElement.classList.remove('upsell-bundle__column--complete');
          console.log(`Column ${columnId} doesn't have enough items - Removed class from column element`);
        } else {
          // Fallback to the wrapper if column element not found
          column.element.classList.remove('upsell-bundle__list-wrapper--complete');
          console.log(`Column ${columnId} doesn't have enough items - Removed class from wrapper (fallback)`);
        }
      }
    }
    
    // Count total selected items and update UI if needed
    function updateButtonCount() {
      let totalSelected = 0;
      
      // Count all added buttons
      Object.values(columnSelections).forEach(column => {
        totalSelected += column.selectedItems;
      });
      
      console.log(`Total selected items: ${totalSelected}`);
      
      // Update UI elements if needed
      const countElement = document.querySelector('.bundle-selected-count');
      if (countElement) {
        countElement.textContent = totalSelected.toString();
      }
      
      // Enable/disable checkout button based on selections
      const requiredTotal = Object.values(columnSelections).reduce((sum, column) => sum + column.requiredItems, 0);
      const checkoutBtn = document.querySelector('.bundle-checkout-btn');
      
      if (checkoutBtn) {
        const isComplete = totalSelected >= requiredTotal;
        checkoutBtn.disabled = !isComplete;
        
        if (isComplete) {
          checkoutBtn.classList.add('bundle-checkout-btn--active');
        } else {
          checkoutBtn.classList.remove('bundle-checkout-btn--active');
        }
      }
    }
    
    // Add this function to handle dynamic pricing updates

    function updateBundlePricing(columnElement) {
      const bundleLoopIndex = columnElement.querySelector('[data-bundle-id]')?.getAttribute('data-bundle-id')?.split('-')[1];
      if (!bundleLoopIndex) return;
      
      // Get bundle data from the column
      const pricingSection = columnElement.querySelector('.bundle-pricing');
      if (!pricingSection) return;
      
      // Get discount percentage and total items required
      const discountPercentage = parseFloat(columnElement.getAttribute('data-discount')) || 0;
      const numberOfItemsToAdd = parseInt(columnElement.querySelector('.upsell-bundle__list-wrapper')?.getAttribute('data-number-of-items')) || 0;
      const totalItemsRequired = numberOfItemsToAdd + 1; // Always add 1 for main product
      
      // Get the main product price
      const mainProductPrice = parseFloat(columnElement.getAttribute('data-main-product-price')) || 0;
      
      // Calculate total price assuming all items will be selected
      let totalPrice = mainProductPrice; // Start with main product
      
      // For the remaining items, use either selected variant price or main product price as fallback
      const listWrappers = columnElement.querySelectorAll('.upsell-bundle__list');
      
      for (let i = 0; i < numberOfItemsToAdd; i++) {
        const listWrapper = listWrappers[i];
        if (!listWrapper) {
          // If no list wrapper, use main product price as fallback
          totalPrice += mainProductPrice;
          continue;
        }
        
        // Check if an item is already added in this list
        const addedButton = listWrapper.querySelector('.bundle-add-btn.added');
        if (addedButton) {
          // Use the price of the selected variant
          const variantPrice = parseFloat(addedButton.getAttribute('data-variant-price')) || mainProductPrice;
          totalPrice += variantPrice;
        } else {
          // Check if a variant is selected (but not added yet)
          const variantSelect = listWrapper.querySelector('.bundle-variant-select');
          if (variantSelect && variantSelect.selectedIndex >= 0) {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            const variantPrice = parseFloat(selectedOption.getAttribute('data-price')) || mainProductPrice;
            totalPrice += variantPrice;
          } else {
            // Fallback to main product price
            totalPrice += mainProductPrice;
          }
        }
      }
      
      // Calculate discount and final price
      const discountAmount = totalPrice * discountPercentage / 100;
      const finalPrice = totalPrice - discountAmount;
      
      // Update the pricing display
      updatePricingDisplay(pricingSection, totalPrice, finalPrice, discountPercentage, discountAmount);
      
      console.log(`Bundle pricing updated: ${totalItemsRequired} items, Total: ${totalPrice}, Final: ${finalPrice}`);
    }

    function updatePricingDisplay(pricingSection, originalPrice, finalPrice, discountPercentage, discountAmount) {
      // Format prices using Shopify's money format
      const formatMoney = (cents) => {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(cents / 100);
      };
      
      // Update crossed out price if it exists
      const crossedPrice = pricingSection.querySelector('.bundle-pricing__price--crossed');
      if (crossedPrice && discountPercentage > 0) {
        crossedPrice.textContent = formatMoney(originalPrice);
      }
      
      // Update final price
      const finalPriceElement = pricingSection.querySelector('.bundle-pricing__price--final');
      if (finalPriceElement) {
        finalPriceElement.textContent = formatMoney(finalPrice);
      }
      
      // Show/hide original price section based on discount
      const originalSection = pricingSection.querySelector('.bundle-pricing__original');
      if (originalSection) {
        originalSection.style.display = discountPercentage > 0 ? 'block' : 'none';
      }
    }
  }
});